import React from 'react'
import Maintenance from '../../components/system/maintenance'

export default function Container(props: any) {
  return <Maintenance />
}
